// extracted by mini-css-extract-plugin
module.exports = {"cower":"Cover_cower__NJgqr","opened":"Cover_opened__sfnlt"};